<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <div class="text-center text-h5 font-weight-light">
          <strong>CONFIGURAÇÃO GERAL</strong>
        </div>
      </v-col>
    </v-row>
    <v-container class="px-16">
      <div class="pa-0 ma-0">
        <div>
          <v-text-field
            type="number"
            label="Quantas horas antes do início da aula, deseja habilitar a reserva? (máx. 168h)"
            required
            suffix="horas"
            min="0"
            max="168"
            v-model="currentUnit.hoursBefore"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
          ></v-text-field>
        </div>
      </div>
      <div class="pa-0 ma-0">
        <div>
          <v-text-field
            type="number"
            label="Quantos minutos após o início da aula, deseja habilitar a reserva?"
            required
            suffix="minutos"
            min="0"
            max="1440"
            v-model="currentUnit.minutesAfter"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
          ></v-text-field>
        </div>
      </div>      
      <div class="pa-0 ma-0">
        <div>
          <v-text-field
            type="number"
            label="Greenwich Mean Time (GMT) (Horário padrão de Brasília GMT -3)"
            required
            suffix="GMT"
            min="-6"
            max="-2"
            v-model="currentUnit.timeZoneOffset"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
          ></v-text-field>
        </div>
      </div>
      <!-- <div class="pa-0 ma-0">
        <div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dates"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-combobox
                v-model="dates"
                multiple
                chips
                medium-chips
                label="Datas desabilitadas para agendamento"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker
              v-model="dates"
              multiple
              no-title
              scrollable
              locale="pt-br"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(dates)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div> 
      </div> -->
      <div class="pa-0 ma-0">
        <div>
          <v-btn class="primary" @click="updateCurrentUnit">Salvar</v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    dates: [],
    menu: false,
  }),
  methods: {
    ...mapActions("snackbar", ["ActionSetSnackbar"]),
    ...mapActions("units", ["ActionFindClassSchedulesList"]),
    ...mapActions("units", ["ActionUpdateUnit"]),

    async updateCurrentUnit() {
      try {
        this.currentUnit.disabledDates = this.dates;
        await this.ActionUpdateUnit(this.currentUnit);
        this.ActionSetSnackbar({
          color: "success",
          text: "Parabéns, salvo com sucesso!",
          timeout: 1000,
        });
      } catch (error) {
        this.ActionSetSnackbar({
          color: "error",
          text: "Oops, ocorreu alguma falha ao salvar!",
          timeout: 2000,
        });
        console.error(error);
      }
    },
  },
  mounted() {
    let results = this.currentUnit.disabledDates.map((date) =>
      date.replace("T00:00:00", "")
    );
    this.dates = results;
  },
  computed: {
    ...mapState("units", ["currentUnit"]),
  },
};
</script>

<style></style>
